import axiosInstance from "core/api/axiosInstance";
import { validateVipUsageFilters } from "../model/vipUsageDates";
import { buildVipUsageReport } from "../model/vipUsageModel";
function readList(payload, label) {
  if (!Array.isArray(payload?.data) || (payload.code !== undefined && payload.code !== 0))
    throw new Error(payload?.message || `Respuesta inválida de ${label}.`);
  if (
    payload.pagination?.hasMore ||
    (Number.isFinite(Number(payload.count)) && Number(payload.count) > payload.data.length)
  )
    throw new Error(`La respuesta de ${label} está incompleta; falta paginación del backend.`);
  return payload.data;
}
export async function getVipUsageService(filters, signal) {
  try {
    const invalid = validateVipUsageFilters(filters);
    if (invalid) throw new Error(invalid);
    const endpoint = process.env.REACT_APP_USO_VIP_API_URL || "/api/isrr/get-use-vip";
    const query = new URLSearchParams({ startDate: filters.startDate, endDate: filters.endDate });
    if (filters.plate) query.set("plate", filters.plate.trim());
    if (filters.groupId) query.set("groupId", String(filters.groupId));
    const urls = [
      `${endpoint}${endpoint.includes("?") ? "&" : "?"}${query}`,
      "/api/tp/get-iserra-groups",
      "/api/tp/get-iserra",
    ];
    const results = await Promise.allSettled(
      urls.map((url) => axiosInstance.get(url, { signal, timeout: 30000 }))
    );
    if (signal?.aborted) return { success: false, isCanceled: true };
    if (results[0].status === "rejected") throw results[0].reason;
    const events = readList(results[0].value.data, "movimientos VIP");
    const warnings = [];
    const catalog = (index, label) => {
      const result = results[index];
      try {
        if (result.status === "rejected") throw result.reason;
        return readList(result.value.data, label);
      } catch (error) {
        if (filters.groupId)
          throw new Error("No se pudo verificar el grupo seleccionado. Intenta nuevamente.");
        warnings.push(
          `No se pudo consultar ${label}; algunos grupos pueden aparecer sin información.`
        );
        return [];
      }
    };
    const groups = catalog(1, "el catálogo de grupos");
    const members = catalog(2, "la asignación de grupos");
    return {
      success: true,
      report: buildVipUsageReport(
        { source: "vip-events", events, groups, members, warnings },
        filters
      ),
    };
  } catch (error) {
    return {
      success: false,
      error: error.response?.data?.message || error.message || "No se pudo consultar Uso de VIP.",
      isCanceled: signal?.aborted || error.code === "ERR_CANCELED",
    };
  }
}
